import { Location } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';

import { IconSize, ShIconModule } from '@stylehaven/components';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    standalone: true,
    selector: 'digihaven-format-preview-link',
    templateUrl: './format-preview-link.component.html',
    styleUrls: ['./format-preview-link.component.scss'],
    imports: [ShIconModule, TranslateModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormatPreviewLinkComponent {
    private readonly location: Location = inject(Location);

    readonly label = input.required<string>();
    readonly recordId = input.required<string>();
    readonly roles = input<string[]>([]);

    readonly iconSize = IconSize;
    readonly href = computed(() => this.location.prepareExternalUrl(`viewer/${this.recordId()}`));
}
